import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useState } from "react";
import AddButton, { DraftButton } from "../buttons/button";
import UploadIcon from "../../assets/icons/upload-icon";
import { Form, Formik } from "formik";
import errorToast from "../helper-components/error-toast";
import Papa from "papaparse";
import { getBackgroundColor } from "../helper-components/helper-function";
import { useDispatch } from "react-redux";
import successToast from "../helper-components/success-toast";
import { uomGroupImportAction } from "../../redux/actions/settings-action";
import { productImportCsvAction } from "../../redux/actions/product-action";
const ProductImportCsvModal = ({
  isModalOpen,
  setIsModalOpen,
  setReload,
  productTables,
  reload,
}) => {
  const [loadingButton, setLoadingButton] = useState(false);
  const dispatch = useDispatch();

  const [uploadDocuments, setUploadDocuments] = useState(productTables);

  const initialValues = {
    itemData: [],
    PurchaseData: [],
    PackingInformation: [],
    SalesData: [],
    InventoryData: [],
    PlanningData: [],
    DiscountData: [],
    RestrictionData: [],
    RemarksData: [],
  };

  const [initialValue, setInitialValue] = useState(initialValues);
  const handleFileUpload = (event, upload, setValues, values) => {
    const file = event.target.files[0];
    if (!file) return;
    event.target.value = null; // This resets the file input
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        const parsedData = results.data;
        if (!parsedData || parsedData.length === 0 || !parsedData[0]) {
          errorToast(
            "Error: The CSV file is empty or contains no valid records."
          );
          return; // Stop further processing
        }
        const fileHeaders = Object.keys(parsedData[0]);

        const isValidTemplate = upload?.expectedHeaders.every((header) =>
          fileHeaders.includes(header)
        );

        console.log(
          upload?.expectedHeaders,
          fileHeaders,
          isValidTemplate,
          "dfsfdsfdsdsfdsfdsfsdfs"
        );
        if (!isValidTemplate) {
          errorToast("Error: CSV template does not match the required format.");
          return;
        }
        // const hasEmptyFields = parsedData.some((row, index) =>
        //   upload.expectedHeaders.some((header) => !row[header]?.trim())
        // );

        // if (hasEmptyFields) {
        //   errorToast(
        //     "Error: Some rows contain empty fields. Please fill all required data."
        //   );
        //   return;
        // }
        if (upload?.documentType === "itemData") {
          setValues({ ...values, itemData: parsedData });
        } else if (upload?.documentType === "PurchaseData") {
          setValues({ ...values, PurchaseData: parsedData });
        } else if (upload?.documentType === "PackingInformation") {
          setValues({ ...values, PackingInformation: parsedData });
        } else if (upload?.documentType === "SalesData") {
          setValues({ ...values, SalesData: parsedData });
        } else if (upload?.documentType === "InventoryData") {
          setValues({ ...values, InventoryData: parsedData });
        } else if (upload?.documentType === "PlanningData") {
          setValues({ ...values, PlanningData: parsedData });
        } else if (upload?.documentType === "DiscountData") {
          setValues({ ...values, DiscountData: parsedData });
        } else if (upload?.documentType === "RestrictionData") {
          setValues({ ...values, RestrictionData: parsedData });
        } else if (upload?.documentType === "RemarksData") {
          setValues({ ...values, RemarksData: parsedData });
        }
        setUploadDocuments((prevDocs) =>
          prevDocs.map((doc) =>
            doc.index === upload.index ? { ...doc, filename: file.name } : doc
          )
        );
      },
      error: (error) => {
        errorToast("Error parsing file:", error);
      },
    });
  };

  function handleSubmit(values, actions) {
    const requiredFields = {
      itemData: "Please upload Item Data",
      PurchaseData: "Please upload Purchase Data",
      PackingInformation: "Please upload Packing Information",

      SalesData: "Please upload Sales Data",
      InventoryData: "Please upload Inventory Data",
      PlanningData: "Please upload Planning Data",
      DiscountData: "Please upload Discount Data",
      RestrictionData: "Please upload Restriction Data",
      RemarksData: "Please upload Remarks Data",
    };

    for (const key in requiredFields) {
      if (!values?.[key] || values[key].length === 0) {
        return errorToast(requiredFields[key]);
      }
    }
    dispatch(productImportCsvAction(values, onSuccess, onError));
  }

  const onSuccess = (data) => {
    setReload(!reload);
    successToast(data?.data?.message);
    setIsModalOpen(false);
  };

  const onError = (data) => {
    errorToast(data?.data?.message);
    setLoadingButton(false);
  };

  return (
    <Transition show={isModalOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto"
        onClose={() => setIsModalOpen(false)}
      >
        <div className="flex min-h-screen px-4 text-center min-w-full">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-100"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-60" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4"
            enterTo="opacity-100 translate-y-0"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-4"
          >
            <div
              style={{ height: "50rem", width: "60%" }}
              className="mx-auto mt-2 text-left align-middle transition-all transform bg-white shadow-xl rounded-xl p-5 "
            >
              <Formik
                key={initialValue}
                enableReinitialize={true}
                initialValues={initialValue}
                // validationSchema={validationSchema}
                onSubmit={(values, actions) => {
                  handleSubmit(values, actions); // Pass values and actions if needed
                  actions.setSubmitting(false); // Notify Formik that submission is done
                }}
              >
                {({ values, errors, setValues }) => {
                  console.log(errors, "dfsfsfdsfdsfsdfdsfs");
                  return (
                    <Form className="h-full">
                      <div className=" flex flex-col h-full">
                        <div
                          className="overflow-auto"
                          style={{ height: "calc(100% - 4rem)" }}
                        >
                          <h2 className="text-center text-lg fw_600  text-000000">
                            Product CSV Import
                          </h2>
                          <div className=" gap-5 w-full flex justify-center mt-10 flex-wrap">
                            {uploadDocuments?.map((upload, index) => (
                              <label
                                style={{
                                  backgroundColor: `${
                                    upload?.filename
                                      ? getBackgroundColor(true, "--primary")
                                      : ""
                                  }`,
                                }}
                                key={index}
                                className="min-w-[30%] min-h-[10rem] border-dotted border-primary border-[3px] rounded-md flex justify-center items-center"
                                htmlFor={`csv-upload-${index}`}
                              >
                                <div className="flex flex-col justify-center">
                                  <div className="flex justify-center">
                                    <UploadIcon
                                      width="20px"
                                      height="20px"
                                      fill="var(--primary)"
                                    />
                                  </div>
                                  <span className="text-center text-primary text-sm mt-3">
                                    {upload?.filename
                                      ? upload?.filename
                                      : upload?.documentType}
                                  </span>
                                </div>
                                <input
                                  type="file"
                                  accept=".csv"
                                  onChange={(e) => {
                                    handleFileUpload(
                                      e,
                                      upload,
                                      setValues,
                                      values
                                    );
                                  }}
                                  className="hidden"
                                  id={`csv-upload-${index}`} // Make the ID unique
                                />
                              </label>
                            ))}
                          </div>
                          <div className="mt-5 flex flex-col gap-10">
                            {uploadDocuments?.map((upload, index) => (
                              <>
                                {upload.filename && (
                                  <div className="flex justify-between">
                                    <div className="flex gap-5 text-000000 fw_600">
                                      <span>{index + 1}.</span>{" "}
                                      <span>{upload?.filename}</span>
                                    </div>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setUploadDocuments((prevDocs) =>
                                          prevDocs.map((doc) =>
                                            doc.index === upload.index
                                              ? { ...doc, filename: "" }
                                              : doc
                                          )
                                        );
                                        // Update form values based on the removed file type
                                        if (
                                          upload.documentType === "UOM group"
                                        ) {
                                          setValues({
                                            ...values,
                                            uomGroup: [],
                                          });
                                        } else if (
                                          upload.documentType === "UOM item"
                                        ) {
                                          setValues({
                                            ...values,
                                            uomGroupItem: [],
                                          });
                                        }
                                      }}
                                      style={{
                                        backgroundColor: getBackgroundColor(
                                          true,
                                          "--error-color"
                                        ),
                                      }}
                                      className="text-F51D00 rounded-md bg-F51D00 px-3 py-1 text-sm"
                                    >
                                      Remove
                                    </button>
                                  </div>
                                )}
                              </>
                            ))}
                          </div>
                        </div>
                        <div className="flex justify-between items-center h-[4rem]">
                          <DraftButton
                            className="text-F94B4B border border-F94B4B  border-solid px-10 py-2 items-center rounded-md flex justify-center fw_600 text-sm"
                            type="button"
                            onclkFn={() => {
                              setInitialValue(initialValues);
                              setUploadDocuments(productTables);
                              setIsModalOpen(false);
                            }}
                            text="Cancel"
                          />
                          <AddButton
                            isDisabled={loadingButton}
                            loading={loadingButton}
                            prefixIcon={false}
                            text="Import"
                            type="submit"
                            // onclkFn={() => {
                            //   setFieldValue("submittedButton", "import");
                            // }}
                          />{" "}
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ProductImportCsvModal;
